export class staticport{
      static porturl ='http://warparasakthi.annaasilicontechnology.com/parasakthischool/';
            // static porturl ='http://localhost:8080/Parasakthiwebsite/';
            // static porturl = 'http://192.168.29.52:8111/sbconsultancy/';
}